import { faEquals } from "@fortawesome/pro-regular-svg-icons";
import { Box } from "@mui/material";

import { Icon } from "@/components/ui-v2";

export const BestMatchAspectRatioIcon = () => (
  <Box
    sx={{
      width: 28,
      height: 28,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <Box
      sx={{
        minWidth: 20,
        minHeight: 20,
        border: "1px solid",
        borderColor: "secondary.3",
        borderRadius: "4px",
        paddingBottom: "1px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Icon icon={faEquals} size="micro" />
    </Box>
  </Box>
);
